'use strict';
var base = require('./base');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,
    // addToCart: base.addToCart,
    images: base.images,

    bulbFinderPDPHeader: function () {
        $('.pdp-header .section-two .how-to-btn').on('click', function () {
            $('.pdp-header').toggleClass('active');
            $(this).toggleClass('active');
        
            if($(this).hasClass('active')) {
                $('.carousel-nav-for-how-to').slick('unslick');
                $('.how-to-carousel-slider').slick('unslick');
            } else {
                $('.how-to-carousel-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: true,
                    infinite: false,
                    asNavFor: '.carousel-nav-for-how-to'
                });

                $('.carousel-nav-for-how-to').slick({
                    slidesToShow: 7,
                    arrows: false,
                    slidesToScroll: 7,
                    asNavFor: '.how-to-carousel-slider',
                    dots: false,
                    centerMode: true,
                    infinite: false,
                    focusOnSelect: true,
                    responsive: [
                    {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                        centerMode: false,
                        slidesToScroll: 1,
                        infinite: false
                    }
                    },
                        {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            centerMode: false
                        }
                    },
                        {
                        breakpoint: 480,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            centerMode: false
                        }
                        }
                    ]
                });
            }
        });
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        var $sizeChartBlock = $('.size-chart');

        if($sizeChartBlock.length) {
            var $sizeChartLink = $sizeChartBlock.find('.size-chart-link');
            var url = $sizeChartLink.attr('href');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data.name) {
                        $sizeChartLink.html(data.name);
                        $sizeChartBlock.show();
                    }
                }
            });
        }

        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    enableApplePay: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            if (response.product.readyToOrder) {
                var applePayButton = $('.apple-pay-pdp', response.$productContainer);
                if (applePayButton.length !== 0) {
                    applePayButton.attr('sku', response.product.id);
                } else {
                    var showApplePay = true;
                    if (typeof $('.cart-and-ipay').data('ipay-enabled') !== 'undefined') {
                        showApplePay = $('.cart-and-ipay').data('ipay-enabled');
                    }
                    if ($('.apple-pay-pdp').length === 0 && showApplePay) { // eslint-disable-line no-lonely-if
                        var applePayButtonIsmlString = '<div class="col col-sm-5 pdp-apple-pay-button">'
                                                    + '<isapplepay class="apple-pay-pdp btn"'
                                                    + 'sku=' + response.product.id + '></isapplepay>'
                                                    + '</div>';
                        $('.cart-and-ipay .row').append(applePayButtonIsmlString);

                        if ($('.cart-and-ipay').data('is-apple-session') === true) {
                            $('.pdp-checkout-button').removeClass('col-12');
                            $('.pdp-checkout-button').addClass('col col-sm-5');
                        }
                    }
                }
            } else {
                $('.pdp-apple-pay-button').remove();
                $('.pdp-checkout-button').removeClass('col col-sm-5');
                $('.pdp-checkout-button').addClass('col-12');
            }
        });
    },
    addBulbFinderLink: function () {
        var docRef = document.referrer;
        if (docRef.includes('BulbFinder-Show')) {
            $('.bulb-finder-link-2').removeClass('d-none');
        } else {
            $('.bulb-finder-link-1').removeClass('d-none');
        }
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
